import { render } from "./RoofField.vue?vue&type=template&id=5092aee7"
import script from "./RoofField.vue?vue&type=script&lang=js"
export * from "./RoofField.vue?vue&type=script&lang=js"

import exportComponent from "/home/avangard/git/toode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__